import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../../shared/locales/no.json';
import ProfileStatus from '../../../utils/ProfileStatus';
import SubmitButton from '../../../components/form/formComponents/SubmitButton';
import MODES from '../../../components/form/onSubmitModes';

export default function UnpublishButton(props) {
    if (props.status !== ProfileStatus.ACTIVE) {
        return null;
    }

    const buttonMode = props.isSaving ? MODES.SAVING : MODES.EDIT;

    return (
        <SubmitButton
            className="button--cta u-ml16"
            id="unpublish-button"
            mode={buttonMode}
            onClick={props.onRequestUnpublish}
            value={props.isSaving ? i18n.Unpublishing : i18n.Unpublish}
        />
    );
}

UnpublishButton.propTypes = {
    isSaving: PropTypes.bool,
    onRequestUnpublish: PropTypes.func.isRequired,
    status: PropTypes.string,
};
